import script from "./WapNurseView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WapNurseView.vue?vue&type=script&lang=ts&setup=true"

import "./WapNurseView.vue?vue&type=style&index=0&id=561dd4d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-561dd4d8"]])

export default __exports__